import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m3 3 7.07 16.97 2.51-7.39 7.39-2.51L3 3z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m13 13 6 6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "MousePointer";
const MousePointer = memo(themed(Icon));
export {
  MousePointer
};
//# sourceMappingURL=mouse-pointer.js.map
